import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class AccessPolicyTypes {
  static accounts: IActionType = new ActionType('ACCESS_POLICY/ACCOUNTS');
  static permissions: IActionType = new ActionType('ACCESS_POLICY/PERMISSIONS');
  static modules: IActionType = new ActionType('ACCESS_POLICY/MODULES');
  static groups: IActionType = new ActionType('ACCESS_POLICY/GROUPS');
  static users: IActionType = new ActionType('ACCESS_POLICY/USERS');
}

export default AccessPolicyTypes;
